import dayjs from "dayjs";

/** Extrai horário ou frequência da posologia FHIR para exibir no card */
export function getMedicationScheduleLabel(fullResource: any): string {
  const repeat = fullResource?.dosageInstruction?.[0]?.timing?.repeat;
  const timeOfDay = repeat?.timeOfDay?.[0];

  if (timeOfDay) {
    const parsed = dayjs(`2000-01-01T${timeOfDay}`);
    if (parsed.isValid()) {
      return parsed.format("h:mm A");
    }
  }

  if (repeat?.period && repeat?.periodUnit === "h") {
    return `A cada ${repeat.period}h`;
  }

  if (repeat?.frequency && repeat?.periodUnit === "d") {
    return `${repeat.frequency}x ao dia`;
  }

  return "Conforme prescrito";
}

/** Rótulo curto em caixa alta (categoria / forma) */
export function getMedicationCategoryLabel(fullResource: any): string {
  const unit =
    fullResource?.dosageInstruction?.[0]?.doseAndRate?.[0]?.doseQuantity?.unit;
  const type = fullResource?.dosageInstruction?.[0]?.doseAndRate?.[0]?.type?.text;

  if (type) return type.toUpperCase().slice(0, 24);
  if (unit) return unit.toUpperCase();
  return "MEDICAMENTO";
}

export function getMedicationStatusLabel(status?: string): string {
  switch (status) {
    case "active":
      return "ATIVO";
    case "stopped":
      return "INTERROMPIDO";
    case "completed":
      return "CONCLUÍDO";
    default:
      return "PENDENTE";
  }
}
